module.exports = __webpack_public_path__ + "img/live04.286e4a30.png";